<template>
	<div class="hero" :style="{ backgroundImage: 'url(' + homeImage + ')' }"></div>
</template>

<script>
	import { mapActions, mapGetters, mapState } from 'vuex'

	export default {
		computed: {
			...mapGetters(['homeImage']),
		},
	}
</script>

<style scoped>
	.hero {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		background-repeat: no-repeat;
		background-position: center center;
	}
</style>
